import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import GraduatedStudentComp from './GraduatedStudentComp'

function GraduatedStudents() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <GraduatedStudentComp/>      
        </div>
    </div>
  )
}

export default GraduatedStudents